import React from "react";

export const Demography = ({ x = 0, y = 0 }) => (
  <g style={{ transform: `translate(${x}px, ${y}px)` }}>
    <rect width={44} height={28} rx={1} fill="#F1F2F6" />

    <line
      x1={2}
      y1={16}
      x2={42}
      y2={16}
      stroke="#8E97A9"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={0.75}
    />
    <g fill="#8E97A9">
      <path d="M4,15V11.08A1.09,1.09,0,0,1,5.08,10h8.84A1.09,1.09,0,0,1,15,11.08V15Z" />
      <path d="M27.5,15V8.08A1.09,1.09,0,0,0,26.42,7H17.58A1.09,1.09,0,0,0,16.5,8.08V15Z" />
      <path d="M40,15V4.3A1.3,1.3,0,0,0,38.7,3H30.3A1.3,1.3,0,0,0,29,4.3V15Z" />
      <path d="M29,17v7.7A1.3,1.3,0,0,0,30.3,26h8.4A1.3,1.3,0,0,0,40,24.7V17Z" />
      <path d="M4,17v7.92A1.09,1.09,0,0,0,5.08,26h8.84A1.09,1.09,0,0,0,15,24.92V17Z" />
      <path d="M16.5,17v4.92A1.09,1.09,0,0,0,17.58,23h8.84a1.09,1.09,0,0,0,1.08-1.08V17Z" />
    </g>
  </g>
);
